import { SpaceLevelLocation } from "@project-rouge/rg-core";
function getSpacesByLevel(levels, requiredSpaces, ground = 0) {
	const spaces = requiredSpaces.filter((space) => !space.consolidationType);
	const lowestFloor = levels[0];
	const groundFloor = ground;
	const roofFloor = levels[levels.length - 1];
	const spacesByLevel = /* @__PURE__ */ new Map();
	for (const level of levels) {
		const levelSpaces = [];
		if (level === lowestFloor) levelSpaces.push(...extractSpacesOfLevel(SpaceLevelLocation.Lowest, spaces));
		if (level === groundFloor) levelSpaces.push(...extractSpacesOfLevel(SpaceLevelLocation.Ground, spaces));
		if (level === roofFloor) levelSpaces.push(...extractSpacesOfLevel(SpaceLevelLocation.Roof, spaces));
		spacesByLevel.set(level, levelSpaces);
	}
	spaces.filter((space) => space.attributes.requiredOnEveryLevel).forEach((space) => {
		for (const spacesOfLevel of spacesByLevel.values()) spacesOfLevel.push(space);
		const i = spaces.indexOf(space);
		spaces.splice(i, 1);
	});
	const consolidationSpaces = requiredSpaces.filter((space) => space.consolidationType);
	for (const level of levels) {
		if (level === lowestFloor) spacesByLevel.get(level).push(...consolidationSpaces.filter((space) => space.attributes.levelLocation && space.attributes.levelLocation.includes(SpaceLevelLocation.Lowest)));
		if (level === groundFloor) spacesByLevel.get(level).push(...consolidationSpaces.filter((space) => space.attributes.levelLocation && space.attributes.levelLocation.includes(SpaceLevelLocation.Ground)));
		if (level === roofFloor) spacesByLevel.get(level).push(...consolidationSpaces.filter((space) => space.attributes.levelLocation && space.attributes.levelLocation.includes(SpaceLevelLocation.Roof)));
		spacesByLevel.get(level).push(...consolidationSpaces.filter((space) => !space.attributes.levelLocation || space.attributes.levelLocation.length === 0));
	}
	if (spaces.length === 0) return { spacesByLevel };
	else return {
		spacesByLevel,
		leftover: spaces
	};
}
function extractSpacesOfLevel(levelTag, spaces) {
	const spacesOfLevel = spaces.filter((space) => space.attributes.levelLocation && space.attributes.levelLocation.includes(levelTag));
	spacesOfLevel.forEach((space) => {
		const i = spaces.indexOf(space);
		spaces.splice(i, 1);
	});
	return spacesOfLevel;
}
export { getSpacesByLevel };

//# sourceMappingURL=index97.js.map